<script lang="ts">
    import Card from "../UiCommenCard.svelte";
    import { Button, Col,Popover } from "sveltestrap";
    import {Direction, PopoverContent, PopoverDetail, Popoveronbottom, Popoveronleft, Popoveronright, Popoverontop} from "../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Direction} headerContent={PopoverDetail} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <Button color="primary" id="toppopover">{Popoverontop}</Button>
            <Popover placement="top" target="toppopover" title="Popover title" >{PopoverContent}</Popover>
            <Button color="primary" id="rightpopover">{Popoveronright}</Button>
            <Popover placement="right" target="rightpopover" >{PopoverContent}</Popover>
            <Button color="primary" id="bottompopover">{Popoveronbottom}</Button>
            <Popover placement="bottom" target="bottompopover" >{PopoverContent}</Popover>
            <Button color="primary" id="leftpopover">{Popoveronleft}</Button>
            <Popover placement="left" target="leftpopover" >{PopoverContent}</Popover>
      </div>
    </Card>
</Col>